
import React, { useState, useEffect, useContext, useRef } from "react";
import { FiUser, FiMenu } from "react-icons/fi";
import { FaPhone, FaTimes } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import { SearchContext } from "../containers/SearchContext";
import Login1 from "../auth/Login1";
import SignUp1 from "../auth/SignUp1";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { IoCloseCircleOutline } from "react-icons/io5";
import Pricing from "../containers/Pricing";

const HorizontalNav = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isSignUpModalOpen, setIsSignUpModalOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { propertyCity, setPropertyCity } = useContext(SearchContext);
  const { searchCity, setSearchCity } = useContext(SearchContext);
  const [inputValue, setInputValue] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [showModal, setShowModal] = useState(false);
  const location = useLocation();
  const history = useHistory();
  const [profileImage, setProfileImage] = useState("");

  const showSearchBar =
    [
      "/searchdashboard",
      "/property",
      "/advisordashboard",
      "/featuredDashboard",
      "/recommendedpropertiesDashboard",
    ].includes(location.pathname) ||
    location.pathname.startsWith("/citywiseproperties");

  const hideTabLinks = showSearchBar;

  useEffect(() => {
    if (!showSearchBar) {
      setSearchCity("");
      setInputValue("");
    }
  }, [location.pathname]);

  const checkLoginStatus = () => {
    const userId = sessionStorage.getItem("accessToken");
    setIsLoggedIn(!!userId);
  };

  useEffect(() => {
    checkLoginStatus();
    const intervalId = setInterval(checkLoginStatus, 1000);
    return () => clearInterval(intervalId);
  }, []);

  const handleLogout = () => {
    setShowModal(true);
  };

  const confirmLogout = () => {
    sessionStorage.clear();
    setShowModal(false);
    toast.success("Logout Successfully");
    setIsLoggedIn(false);
    history.push("/");
  };

  useEffect(() => {
    if (isDropdownOpen) {
      const timer = setTimeout(() => {
        setIsDropdownOpen(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isDropdownOpen]);

  const [freePostCount, setFreePostCount] = useState(0);
  const userId = sessionStorage.getItem("accessToken");
  const userType = sessionStorage.getItem("user_type");

  useEffect(() => {
    const checkPostLimits = async () => {
      try {
        const profileForm = new FormData();
        profileForm.append("user_id", userId);

        const profileResponse = await axios.post(
          `${process.env.REACT_APP_API_URL}/cust_api/get_profile`,
          profileForm,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        const countData = profileResponse?.data?.count_data;

        if (countData) {
          setFreePostCount(countData.free_post_count || 0);
        }
        setProfileImage(profileResponse?.data?.data?.profile_image || "");
      } catch (error) {
        console.error("Error checking post limits:", error);
      }
    };

    if (userId) {
      checkPostLimits();
    }
  }, [userId]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Prevent background scrolling when modal is open
  useEffect(() => {
    if (isLoginModalOpen || isSignUpModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isLoginModalOpen, isSignUpModalOpen]);

  {/*
  Same component body as before: all state, handlers, Links, routes, modals
  (Login1 / SignUp1 / logout) and conditions (showSearchBar, isLoggedIn,
  freePostCount, profileImage, isDropdownOpen, isMobileMenuOpen, showModal)
  are untouched. Only sizing, semantics and accessibility/SEO attributes changed.
  Paste this as the `return (...)` of your existing component.
*/}

  

  {/*
  Same component body as before: all state, handlers, Links, routes, modals
  (Login1 / SignUp1 / logout) and conditions (showSearchBar, isLoggedIn,
  freePostCount, profileImage, isDropdownOpen, isMobileMenuOpen, showModal)
  are untouched. Only sizing, semantics and accessibility/SEO attributes changed.
  Paste this as the `return (...)` of your existing component.
*/}
return (
  <header className="sticky top-0 z-40 bg-white shadow-sm border-b border-gray-200">
    {/* SEO / AEO / GEO : brand + contact structured data (edit/merge with your site-wide Organization schema if you already have one) */}
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "ZeroBriks",
          logo: "/app1.png",
          parentOrganization: { "@type": "Organization", name: "ZeroBriks" },
          areaServed: { "@type": "Country", name: "India" },
          contactPoint: {
            "@type": "ContactPoint",
            telephone: "+91-8600199570",
            contactType: "customer support",
            areaServed: "IN",
            availableLanguage: ["English", "Hindi"],
          },
        }),
      }}
    />

    <div className="max-w-[1160px] mx-auto px-3 sm:px-4 lg:px-6 py-2 flex items-center justify-between gap-3">
      {/* Left: Logo & Tagline */}
      <div className="flex items-center gap-3 shrink-0">
        <Link to="/" aria-label="ZeroBriks" className="flex items-center">
          <img
            src="/app1.png"
            alt="ZeroBriks Logo"
            className="w-[120px] md:w-[120px] h-auto object-contain"
          />
        </Link>
        <div className="hidden xl:flex items-center gap-2 pl-3 border-l border-gray-300">
          <span className="text-[9px] leading-tight text-gray-600 font-medium">
            A Brand of <br />
            <strong className="text-gray-800 font-semibold">NowayBroker</strong>
          </span>
        </div>
      </div>

      {/* Center: Navigation Links / Search Bar */}
      <nav
        aria-label="Main navigation"
        className="hidden lg:flex items-center lg:space-x-4 xl:space-x-5"
      >
        {showSearchBar ? (
          <div
            role="search"
            className="flex items-center gap-2 my-border rounded-md px-2.5 py-1 w-[280px] bg-white"
          >
            {searchCity && (
              <span className="flex items-center px-2 py-0.5 text-[11px] text-black bg-gray-200 rounded-full">
                {searchCity}
                <button
                  type="button"
                  aria-label={`Clear location filter ${searchCity}`}
                  className="ml-1.5 text-black hover:text-gray-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#700c28] rounded"
                  onClick={() => setSearchCity("")}
                >
                  ✕
                </button>
              </span>
            )}
            <input
              type="text"
              aria-label="Search location"
              className="bg-transparent border-none outline-none text-[11px] w-full"
              placeholder="Search Location..."
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" && inputValue.trim() !== "") {
                  setSearchCity(inputValue.trim());
                  setInputValue("");
                }
              }}
            />
          </div>
        ) : (
          <ul className="flex items-center lg:space-x-4 xl:space-x-5 mb-0 pl-0 list-none">
            <li>
              <Link
                to={{ pathname: "/property", state: { propertyType: "Buy" } }}
                className="text-[9px] xl:text-xs font-semibold tracking-wide text-gray-700 no-underline transition hover:text-[#700c28] whitespace-nowrap"
              >
                Buy
              </Link>
            </li>
            <li>
              <Link
                to={{ pathname: "/property", state: { propertyType: "Rent" } }}
                className="text-[9px] xl:text-xs font-semibold tracking-wide text-gray-700 no-underline transition hover:text-[#700c28] whitespace-nowrap"
              >
                Rent
              </Link>
            </li>
            <li>
              <Link
                to={{ pathname: "/property", state: { propertyType: "PG" } }}
                className="text-[9px] xl:text-xs font-semibold tracking-wide text-gray-700 no-underline transition hover:text-[#700c28] whitespace-nowrap"
              >
                PG
              </Link>
            </li>
            <li>
              <Link
                to={{ pathname: "/property", state: { propertyType: "Plots/Land" } }}
                className="text-[9px] xl:text-xs font-semibold tracking-wide text-gray-700 no-underline transition hover:text-[#700c28] whitespace-nowrap"
              >
                Plots/Land
              </Link>
            </li>
            <li>
              <Link
                to={{ pathname: "/property", state: { propertyType: "Commercial" } }}
                className="text-[9px] xl:text-xs font-semibold tracking-wide text-gray-700 no-underline transition hover:text-[#700c28] whitespace-nowrap"
              >
                Commercial
              </Link>
            </li>
            <li>
              <Link
                to="/advisordashboard?label=Builder"
                className="text-[9px] xl:text-xs font-semibold tracking-wide text-gray-700 no-underline transition hover:text-[#700c28] whitespace-nowrap"
              >
                Projects
              </Link>
            </li>
            <li>
              <Link
                to="/allproperties"
                className="text-[9px] xl:text-xs font-semibold tracking-wide text-gray-700 no-underline transition hover:text-[#700c28] whitespace-nowrap"
              >
                Explore Cities
              </Link>
            </li>
            <li>
              <Link
                to="/pricing"
                className="text-[9px] xl:text-xs font-semibold tracking-wide text-gray-700 no-underline transition hover:text-[#700c28] whitespace-nowrap"
              >
                Plans
              </Link>
            </li>
          </ul>
        )}
      </nav>

      {/* Right Side Actions */}
      <div className="hidden lg:flex items-center space-x-2 shrink-0">
        {/* Download App Button */}
        <Link
          to="/download"
          className="flex items-center gap-1 px-2.5 py-1 text-[9px] font-semibold text-[#700c28] border border-[#700c28] rounded-lg hover:bg-[#fdf2f4] no-underline transition-colors whitespace-nowrap"
        >
          <span aria-hidden="true" className="text-xs">📱</span>
          <span>Download App</span>
        </Link>

        {/* Post Property Button */}
        {isLoggedIn ? (
          <Link
            to="/add_new_property"
            className="flex items-center gap-1 px-3 py-1 text-[11px] font-semibold text-white bg-[#700c28] rounded-lg hover:bg-[#580920] no-underline transition-colors shadow-sm whitespace-nowrap"
          >
            <span>Post Property</span>
            {freePostCount > 0 && (
              <span className="px-1.5 py-px text-[9px] font-bold text-gray-900 bg-amber-400 rounded-full">
                FREE
              </span>
            )}
          </Link>
        ) : (
          <button
            type="button"
            onClick={() => setIsLoginModalOpen(true)}
            className="flex items-center gap-1 px-3 py-1 text-[11px] font-semibold text-white bg-[#700c28] rounded-lg hover:bg-[#580920] transition-colors shadow-sm cursor-pointer whitespace-nowrap"
          >
            <span>Post Property</span>
            <span className="px-1.5 py-px text-[9px] font-bold text-gray-900 bg-amber-400 rounded-full">
              FREE
            </span>
          </button>
        )}

        {/* Dialer Icon */}
        <a
          href="tel:+918681800029"
          aria-label="Call ZeroBriks"
          className="w-7 h-7 rounded-full bg-gray-100 flex items-center justify-center text-gray-700 hover:bg-gray-200 transition-colors"
          title="Call Us"
        >
          <FaPhone size={11} aria-hidden="true" />
        </a>

        {/* Profile / User Menu Dropdown */}
        <div className="relative" ref={dropdownRef}>
          {isLoggedIn ? (
            <button
              type="button"
              aria-label="Open account menu"
              aria-haspopup="true"
              aria-expanded={isDropdownOpen}
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              className="focus:outline-none focus-visible:ring-2 focus-visible:ring-[#700c28] rounded-full flex items-center"
            >
              {profileImage && profileImage !== "null" && profileImage.trim() !== "" ? (
                <img
                  src={profileImage}
                  alt="Profile"
                  className="object-cover w-7 h-7 border border-gray-300 rounded-full shadow-sm"
                />
              ) : (
                <div className="w-7 h-7 rounded-full bg-gray-100 border border-gray-300 flex items-center justify-center text-gray-700">
                  <FiUser size={15} aria-hidden="true" />
                </div>
              )}
            </button>
          ) : (
            <button
              type="button"
              onClick={() => setIsLoginModalOpen(true)}
              aria-label="Login or sign up"
              className="w-7 h-7 rounded-full bg-gray-100 border border-gray-300 flex items-center justify-center text-gray-700 hover:bg-gray-200 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[#700c28]"
              title="Login / Signup"
            >
              <FiUser size={15} aria-hidden="true" />
            </button>
          )}

          {/* Dropdown Menu */}
          {isDropdownOpen && isLoggedIn && (
            <div className="absolute right-0 z-50 mt-2 bg-white border border-gray-200 rounded-lg shadow-xl w-40 py-1">
              <Link
                to={{ pathname: "/dashboard", state: { page: "profile" } }}
                onClick={() => setIsDropdownOpen(false)}
                className="block px-3 py-1.5 text-[11px] text-gray-800 no-underline hover:bg-gray-50"
              >
                Profile
              </Link>
              <Link
                to={{ pathname: "/dashboard", state: { page: "myProperties" } }}
                onClick={() => setIsDropdownOpen(false)}
                className="block px-3 py-1.5 text-[11px] text-gray-800 no-underline hover:bg-gray-50"
              >
                My Properties
              </Link>
              <Link
                to={{ pathname: "/dashboard", state: { page: "myVirtualtour" } }}
                onClick={() => setIsDropdownOpen(false)}
                className="block px-3 py-1.5 text-[11px] text-gray-800 no-underline hover:bg-gray-50"
              >
                My Virtual Tour
              </Link>
              <Link
                to={{ pathname: "/dashboard", state: { page: "myFavourite" } }}
                onClick={() => setIsDropdownOpen(false)}
                className="block px-3 py-1.5 text-[11px] text-gray-800 no-underline hover:bg-gray-50"
              >
                My Favourites
              </Link>
              <Link
                to={{ pathname: "/dashboard", state: { page: "saveSerches" } }}
                onClick={() => setIsDropdownOpen(false)}
                className="block px-3 py-1.5 text-[11px] text-gray-800 no-underline hover:bg-gray-50"
              >
                Saved Searches
              </Link>
              <div className="border-t border-gray-100 my-1"></div>
              <button
                type="button"
                onClick={() => {
                  setIsDropdownOpen(false);
                  handleLogout();
                }}
                className="w-full text-left px-3 py-1.5 text-[11px] text-red-600 font-semibold hover:bg-red-50 transition-colors"
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Mobile Menu Toggle Button */}
      <div className="flex items-center gap-1.5 lg:hidden">
        <a
          href="tel:+91 8681800029"
          aria-label="Call ZeroBriks"
          className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-gray-700"
        >
          <FaPhone size={12} aria-hidden="true" />
        </a>
        <button
          type="button"
          aria-label={isMobileMenuOpen ? "Close menu" : "Open menu"}
          aria-expanded={isMobileMenuOpen}
          aria-controls="mobile-menu"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="p-2 text-gray-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#700c28] rounded"
        >
          {isMobileMenuOpen ? (
            <FaTimes size={18} aria-hidden="true" />
          ) : (
            <FiMenu size={18} aria-hidden="true" />
          )}
        </button>
      </div>
    </div>

    {/* Mobile Drawer Menu */}
    {isMobileMenuOpen && (
      <nav
        id="mobile-menu"
        aria-label="Mobile navigation"
        className="lg:hidden bg-white border-t border-gray-200 px-4 py-3 space-y-2.5 shadow-lg max-h-[calc(100vh-56px)] overflow-y-auto"
      >
        <ul className="space-y-0.5 pl-0 list-none mb-0">
          <li>
            <Link
              to={{ pathname: "/property", state: { propertyType: "Buy" } }}
              onClick={() => setIsMobileMenuOpen(false)}
              className="block text-[13px] font-semibold text-gray-800 py-2 no-underline"
            >
              Buy
            </Link>
          </li>
          <li>
            <Link
              to={{ pathname: "/property", state: { propertyType: "Rent" } }}
              onClick={() => setIsMobileMenuOpen(false)}
              className="block text-[13px] font-semibold text-gray-800 py-2 no-underline"
            >
              Rent
            </Link>
          </li>
          <li>
            <Link
              to={{ pathname: "/property", state: { propertyType: "PG" } }}
              onClick={() => setIsMobileMenuOpen(false)}
              className="block text-[13px] font-semibold text-gray-800 py-2 no-underline"
            >
              PG
            </Link>
          </li>
          <li>
            <Link
              to={{ pathname: "/property", state: { propertyType: "Plots/Land" } }}
              onClick={() => setIsMobileMenuOpen(false)}
              className="block text-[13px] font-semibold text-gray-800 py-2 no-underline"
            >
              Plots/Land
            </Link>
          </li>
          <li>
            <Link
              to={{ pathname: "/property", state: { propertyType: "Commercial" } }}
              onClick={() => setIsMobileMenuOpen(false)}
              className="block text-[13px] font-semibold text-gray-800 py-2 no-underline"
            >
              Commercial
            </Link>
          </li>
          <li>
            <Link
              to="/advisordashboard?label=Builder"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block text-[13px] font-semibold text-gray-800 py-2 no-underline"
            >
              Projects
            </Link>
          </li>
          <li>
            <Link
              to="/allproperties"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block text-[13px] font-semibold text-gray-800 py-2 no-underline"
            >
              Explore Cities
            </Link>
          </li>
          <li>
            <Link
              to="/pricing"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block text-[13px] font-semibold text-gray-800 py-2 no-underline"
            >
              Plans
            </Link>
          </li>
        </ul>

        <div className="pt-2.5 border-t border-gray-100 flex flex-col gap-2">
          <Link
            to="/download"
            onClick={() => setIsMobileMenuOpen(false)}
            className="py-2 text-center text-xs font-semibold text-[#700c28] border border-[#700c28] rounded-lg no-underline"
          >
            Download Mobile App
          </Link>

          {isLoggedIn ? (
            <Link
              to="/add_new_property"
              onClick={() => setIsMobileMenuOpen(false)}
              className="py-2 text-center text-xs font-semibold text-white bg-[#700c28] rounded-lg no-underline shadow-sm"
            >
              Post Property FREE
            </Link>
          ) : (
            <button
              type="button"
              onClick={() => {
                setIsMobileMenuOpen(false);
                setIsLoginModalOpen(true);
              }}
              className="py-2 text-center text-xs font-semibold text-white bg-[#700c28] rounded-lg shadow-sm cursor-pointer"
            >
              Post Property FREE
            </button>
          )}

          {isLoggedIn ? (
            <button
              type="button"
              onClick={() => {
                setIsMobileMenuOpen(false);
                handleLogout();
              }}
              className="py-2 text-center text-xs font-semibold text-red-600 bg-red-50 rounded-lg cursor-pointer"
            >
              Logout
            </button>
          ) : (
            <button
              type="button"
              onClick={() => {
                setIsMobileMenuOpen(false);
                setIsLoginModalOpen(true);
              }}
              className="py-2 text-center text-xs font-semibold text-gray-800 bg-gray-100 rounded-lg cursor-pointer"
            >
              Login / Sign Up
            </button>
          )}
        </div>
      </nav>
    )}

    {/* Logout Confirmation Modal */}
    {showModal && (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
        <div
          role="dialog"
          aria-modal="true"
          aria-labelledby="logout-title"
          className="relative p-5 text-center bg-white shadow-xl rounded-xl w-full max-w-[310px]"
        >
          <button
            type="button"
            aria-label="Close dialog"
            className="absolute text-gray-500 hover:text-gray-800 top-2.5 right-2.5"
            onClick={() => setShowModal(false)}
          >
            <IoCloseCircleOutline size={20} aria-hidden="true" />
          </button>

          <h2 id="logout-title" className="text-base font-bold text-gray-900 mt-1.5">
            Are you sure?
          </h2>
          <p className="mt-1 text-[11px] text-gray-600">
            You will be logged out of your account.
          </p>

          <div className="flex justify-center gap-2.5 mt-4">
            <button
              type="button"
              className="px-4 py-1.5 text-[11px] font-semibold text-white bg-[#700c28] rounded-lg hover:bg-[#580920] transition-colors"
              onClick={confirmLogout}
            >
              Yes, Logout
            </button>
            <button
              type="button"
              className="px-4 py-1.5 text-[11px] font-semibold text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
              onClick={() => setShowModal(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    )}

    {/* Auth Modals */}
    <Login1
      isOpen={isLoginModalOpen}
      onClose={() => setIsLoginModalOpen(false)}
      onSwitchToSignUp={() => {
        setIsLoginModalOpen(false);
        setIsSignUpModalOpen(true);
      }}
    />

    <SignUp1
      isOpen={isSignUpModalOpen}
      onClose={() => setIsSignUpModalOpen(false)}
      onSwitchToLogin={() => {
        setIsSignUpModalOpen(false);
        setIsLoginModalOpen(true);
      }}
    />
  </header>
);
};

export default HorizontalNav;